import { TransportMethodEnum } from 'api';
import { SelectField, SelectFieldProps } from 'form';

export const TRANSPORT_METHOD_OPTIONS = [
  {
    label: '20ft Container',
    value: TransportMethodEnum['20FT_CONTAINER'],
  },
  {
    label: '40ft Container',
    value: TransportMethodEnum['40FT_CONTAINER'],
  },
  {
    label: 'Curtain side',
    value: TransportMethodEnum.CS,
  },
  {
    label: 'Walking Floor',
    value: TransportMethodEnum.WF,
  },
];

type TransportMethodProps = Omit<SelectFieldProps, 'options' | 'name' | 'label'>;

export const TransportMethod = ({ ...props }: TransportMethodProps) => (
  <SelectField
    label="Transport method"
    name="transport_method"
    options={TRANSPORT_METHOD_OPTIONS}
    fullWidth={true}
    infoTooltip="Method using which the material will be transported."
    {...props}
  />
);
